<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">节目管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="节目名称" prop="showName">
                <el-input
                  v-model="data.showName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否发布：" prop="publishStatus">
                <el-switch
                  v-model="data.publishStatus"
                  :disabled="!IsEdit"
                  active-text="是"
                  inactive-text="否"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="节目类型" prop="showType">
                <el-select
                  v-model="data.showType"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ItemTypeArr"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="data.showType == 'mp3'||data.showType == 'MP3'">
            <el-col :span="12">
              <el-form-item label="节目音频">
                <el-input
                  v-model="data.mp3Name"
                  :disabled="!IsEdit"
                ></el-input>
                <!-- <el-button>试听</el-button> -->
              </el-form-item>
            </el-col>
            <el-upload
              class="upload-demo"
              :http-request="uploadFileData"
              :data="uploadData"
              accept=".mp3"
              :show-file-list="false"
              :file-list="fileList"
              :before-upload="beforeupload"
              :on-success="uploadsuccess"
              :on-progress="uploadProgress"
              :on-error="uploadError"
              :on-preview="handlePreview"
            >
              <el-button :disabled="!IsEdit">点击上传</el-button>
            </el-upload>
            <!-- <el-button>点击上传</el-button>
            <el-button>试听</el-button> -->
          </el-row>
          <el-row v-if="data.showType == 'text'">
            <el-col :span="24">
              <el-form-item label="节目内容" prop="content">
                <el-input
                  v-model="data.content"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 10 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-footer>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import { getDictType, addBroadcastShow,BroadcastShowInfo,editBroadcastShow } from "@/api/src/broadcast";
import { uploadFile } from "@/api/src/file.js";
export default {
  name: "BroadcastProgramInfo",
  controller: "UI",
  action: "BroadcastProgramInfo",
  data() {
    return {
      data: {
        showName: "",
        publishStatus:"0",
        content:"",
        mp3Url:"",
        mp3Name:""
      },
      ItemTypeArr: [
        // { value: 1, label: "广播词" },
        // { value: 2, label: "MP3" },
      ],
      IsEdit: false,
      rules: {
        showName: [
          { required: true, message: "请输入节目名称", trigger: "blur" },
        ],
        showType: [
          { required: true, message: "请选择节目类型", trigger: "change" },
        ],
      },
      loading: false,
      loadingText: "加载中...",
      uploadData: {
        module: "BroadcastProgramManager", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid(),
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    this.getDict()
  },
  computed: {
    // httpRequest() {
    //   uploadFile().
    //   return ZJApp.ZJApis.ZJUploader.upload;
    // },
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getDict(){
      getDictType({type:"show_type"}).then(res=>{
        //  console.log("res")
        //  console.log(res)
         if(res.code==200){
          this.ItemTypeArr = res.rows;
         }
      })
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        BroadcastShowInfo({id:InfoId}).then(res=>{
          if(res.code==200){
            this.data = res.data;
          }else{
            this.errmsg("服务异常，请联系管理员！");
          }
        })
      }
    },
    //返回按钮
    onBack() {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/plugin/broadcast/UI/BroadcastProgramView",
        // query: {
        //   type: "add",
        // },
      });
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      if (this.$route.query.type == "edit") {
        //编辑
        editBroadcastShow(this.data).then(res=>{
          this.loading = false;
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功！"
            });
            // this.$router.go(-1); //返回上一层
            this.onBack()
          }else{
            this.errmsg("保存失败，请联系管理员！");
          }
        })
   
      } else {

        addBroadcastShow(this.data).then(res=>{
          this.loading = false;
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功！"
            });
            this.onBack()
            // this.$router.go(-1); //返回上一层
            
          }else{
            this.errmsg("保存失败，请联系管理员！");
          }
        })
      }
    },
    beforeupload: function(file) {
      // this.uploadData.assocID = this.uuid;
      // this.loading = true;
      // this.loadingText = "上传中... 0%";
      const isLt2M = file.size / 1024 / 1024 < 11;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 11MB!');
        }
        return  isLt2M;
    },
    uploadFileData(file){
      console.log(file)
      this.data.mp3Name = file.file.name
      uploadFile(file.file).then(res=>{
        // console.log("上传文件")
        // console.log(res)
        this.loading = false;
        if(res.code==200){
          this.data.mp3Url = res.data;
          let obj = {
            name:this.data.mp3Name,
            url:res.data
          }
          this.fileList.push(obj);
          this.$message({
              type: "success",
              message: "上传成功！"
            });
        }else{
          this.errmsg("上传失败！");
        }
      })
    },
    uploadsuccess: function(obj) {
      // this.loading = false;
      // this.data.FileID = obj.FileID;
      // this.data.FileName = obj.FileName;
      // console.log(obj);
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
  },
};
</script>
